import {Pipe, PipeTransform} from '@angular/core';

export const PUBLISHING_FALLBACK = 'Publishing ...';

/**
 * The in-progress text of a publish process: the stage message the PublishPOItem state machine
 * writes, or the generic text while there is none yet. "in progress" is the placeholder the process
 * record is created with, not a stage, so it falls back too.
 */
@Pipe({
  name: 'publishStatus'
})
export class PublishStatusPipe implements PipeTransform {

  transform(process: { message?: string | null } | null | undefined): string {
    const message = process?.message?.trim();
    if (!message || message.toLowerCase() === 'in progress') {
      return PUBLISHING_FALLBACK;
    }
    return message;
  }
}
